<div class="text">
  {{ 'tlc.hr_assistant.chat_trigger_text' | translate }}
  <hr-assistant-icon class="icon" [size]="24" />
</div>
